
import React, { PureComponent } from "react";
import styles from "./Distribution.scss";
import { getLocalizedName, getOrder } from "../../../roles";
import { translate, Interpolate } from "react-i18next";

export type Distribution_Props = {
  clanId: number;
  members: Array<any>; // TODO add Member description
  distributionList: Array<number>;
  id: number;
  distributionPlayerFilter: string;
  isDistributionFilterInputVisible: boolean;
  sortDirection: null | "ask" | "desk";
  sortField: string | null;
  treasuryMinDaysInClan: number;

  fetchMembers: (clanId: number) => void;
  toggleDistributionMembers: (members: Array<any>, toggleAll: boolean) => void;
  showDistributionDialog: () => void;
  setDistributionFilter: (value: string) => void;
  toggleIsDistributionFilterVisible: () => void;
  setSortField: (field: string) => void;
};

export type DistributionMember = {
  abnormalResults: boolean;
  accumulativeClanResource: number;
  battlesCount: number;
  battlesPerDay: number;
  damagePerBattle: number;
  daysInClan: number;
  expPerBattle: number;
  fragsPerBattle: number;
  id: number;
  isBanned: boolean;
  isBonusActivated: boolean;
  isHiddenStatistics: boolean;
  isPress: boolean;
  lastBattleTime: any;
  leveling: number;
  name: string;
  onlineStatus: boolean;
  profileLink: string;
  rank: number;
  roleName: string;
  seasonId: null | number;
  seasonRank: null | number;
  winsPercentage: number;
};
import { FormattedLastBattleTime } from "../../UIKit/UIKit";
import { Button, Checkbox, Table, TableRow, TableHead, TableBodyCell, TableHeadCell, TableBody, IconTable, DivTooltip, TooltipBody, ClanMember, ClanRole, SearchInput, StickyHeader, HiddenStatisticsIcon } from "@wg/wows-react-uikit";
import { t, x } from "../../../helpers/localization";

export type Distribution_State = {
  neverSorted: boolean;
};

class Distribution extends PureComponent<Distribution_Props, Distribution_State> {


  state = {
    neverSorted: true
  };

  componentWillUnmount() {
    this.props.toggleDistributionMembers([], true);
    this.setSortField('');
  }

  toggleMember = (member: any) => () => {
    this.props.toggleDistributionMembers([member.id], false);
  };

  toggleAllMembers = () => {
    this.props.toggleDistributionMembers(this.props.members.filter(item => {
      return item.daysInClan >= this.props.treasuryMinDaysInClan;
    }).map(item => item.id), true);
  };

  isCheckBoxChecked = (id: number) => {
    const filter = this.props.distributionList.filter(m => {
      return m === id;
    });
    return filter.length > 0;
  };

  sort = (a: DistributionMember, b: DistributionMember) => {

    if (this.props.sortField) {

      let aField = a[this.props.sortField];
      let bField = b[this.props.sortField];


      if (this.props.sortField === 'roleName') {
        aField = getOrder(aField);
        bField = getOrder(bField);
      }

      if (typeof aField === 'number' && typeof bField === 'number') {
        if (this.props.sortDirection === 'ask') {
          return aField - bField;
        } else if (this.props.sortDirection === 'desc') {
          return bField - aField;
        } else {
          return 0;
        }
      }

      if (typeof aField === 'string' && typeof bField === 'string') {

        if (this.props.sortDirection === 'ask') {
          return aField.localeCompare(bField);
        } else if (this.props.sortDirection === 'desc') {
          return bField.localeCompare(aField);
        } else {
          return 0;
        }
      }

      return 0;
    } else {
      return 0;
    }
  };

  setSortField = (field: string) => {
    this.props.setSortField(field);
    if (this.state.neverSorted) {
      this.setState({
        neverSorted: false
      });
    }
  };

  render() {

    return <div className={styles.wrapper}>
                <div className={styles.tableWrapper} id={'stickyHeaderContainer'}>
                    <Table>
                        <StickyHeader containerId={'stickyHeaderContainer'}>
                            <TableHead>
                                <TableHeadCell modify={'check'}>
                                    <Checkbox isChecked={(this.props.members.length > 0 && this.props.members.length === this.props.distributionList.length)} isDisabled={false} onChange={this.toggleAllMembers} />
                                </TableHeadCell>
                                <TableHeadCell modify={'role'} isSortable={true} isActive={this.props.sortField === 'roleName' && !this.state.neverSorted} onClick={() => {
                this.setSortField('roleName');
              }}>

                                    <IconTable glyph={'roles'} />
                                    <DivTooltip className={styles.absoluteTooltip} tooltipBody={<TooltipBody>
                                                {t('Должность')}
                                            </TooltipBody>} />
                                </TableHeadCell>
                                <TableHeadCell modify={'basis'} isSortable={true} isActive={this.props.sortField === 'name'} align={this.props.isDistributionFilterInputVisible ? 'flex-end' : undefined} onClick={() => {
                if (!this.props.isDistributionFilterInputVisible) {
                  this.setSortField('name');
                }
              }}>
                                    {!this.props.isDistributionFilterInputVisible ? <div className={styles.inlineSides}>
                                            {t('Игрок')}
                                            <DivTooltip tooltipBody={<TooltipBody>
                                                        {t('Найти игрока')}
                                                    </TooltipBody>}>
                                                <IconTable glyph={'search'} onClick={this.props.toggleIsDistributionFilterVisible} />
                                            </DivTooltip>

                                        </div> : <SearchInput onChange={this.props.setDistributionFilter} onClose={this.props.toggleIsDistributionFilterVisible} value={this.props.distributionPlayerFilter} placeholder={t('Поиск')} closeTooltip={t('Скрыть поиск')} autoFocus={true} isFullwidth={true} />}
                                </TableHeadCell>

                                <TableHeadCell modify={'right'} isSortable={true} align={'flex-end'} isActive={this.props.sortField === 'battlesCount'} onClick={() => {
                this.setSortField('battlesCount');
              }}>

                                    <IconTable glyph={'battles'} />
                                    {t('CBTL')}
                                    <DivTooltip className={styles.absoluteTooltip} tooltipBody={<TooltipBody>
                                                {t('Количество клановых боев')}
                                            </TooltipBody>} />
                                </TableHeadCell>
                                <TableHeadCell modify={'right'} isSortable={true} align={'flex-end'} isActive={this.props.sortField === 'accumulativeClanResource'} onClick={() => {
                this.setSortField('accumulativeClanResource');
              }}>
                                    <IconTable glyph={'clan-resource'} />
                                    <DivTooltip className={styles.absoluteTooltip} tooltipBody={<TooltipBody>
                                                {t('Количество баррелей нефти, добытых в составе клана')}
                                            </TooltipBody>} />
                                </TableHeadCell>
                                <TableHeadCell modify={'right'} isSortable={true} align={'flex-end'} isActive={this.props.sortField === 'daysInClan'} onClick={() => {
                this.setSortField('daysInClan');
              }}>
                                    <IconTable glyph={'days-in-clan'} />
                                    {t('Дни')}
                                    <DivTooltip className={styles.absoluteTooltip} tooltipBody={<TooltipBody>
                                                {t('Количество дней в клане')}
                                            </TooltipBody>} />
                                </TableHeadCell>
                                <TableHeadCell modify={'right'} isSortable={true} align={'flex-end'} isActive={this.props.sortField === 'lastBattleTime'} onClick={() => {
                this.setSortField('lastBattleTime');
              }}>
                                    <IconTable glyph={'last-battle-time'} />
                                    {t('LBT')}
                                    <DivTooltip className={styles.absoluteTooltip} tooltipBody={<TooltipBody>
                                                {t('Время последнего боя')}
                                            </TooltipBody>} />
                                </TableHeadCell>
                            </TableHead>
                        </StickyHeader>

                        <TableBody>
                            {this.props.members.filter(member => {
              if (this.props.distributionPlayerFilter.length > 0) {
                return member.name.toLowerCase().indexOf(this.props.distributionPlayerFilter.toLowerCase()) !== -1;
              } else {
                return member;
              }
            }).sort(this.sort).map((member, index) => {

              const isOwn = this.props.id === member.id;
              const isDisabled = member.daysInClan < this.props.treasuryMinDaysInClan;

              return <TableRow key={`DistributionRow${index}`} isHovering onClick={this.toggleMember(member)} isOwn={isOwn} isDisabled={isDisabled}>
                                        <TableBodyCell modify={'check'}>
                                            <Checkbox isChecked={this.isCheckBoxChecked(member.id)} isDisabled={isDisabled} onChange={this.toggleMember(member)} />
                                        </TableBodyCell>
                                        <TableBodyCell modify={'role'}>
                                            <ClanRole role={member.roleName} isLarger={true} />
                                        </TableBodyCell>
                                        <TableBodyCell modify={'basis'}>
                                            <ClanMember id={member.id} name={member.name} role={getLocalizedName(member.roleName)} isOwn={isOwn} hasPermanentBan={false} isHiddenStatistics={false} isHighlightedAdmittance={false} />
                                        </TableBodyCell>
                                        <TableBodyCell modify={'right'}>
                                            {member.isHiddenStatistics ? <HiddenStatisticsIcon t={t} /> : `${member.battlesCount}`}
                                        </TableBodyCell>
                                        <TableBodyCell modify={'right'}>
                                            {`${member.accumulativeClanResource}`}
                                        </TableBodyCell>
                                        <TableBodyCell modify={'right'}>
                                            {`${member.daysInClan}`}
                                        </TableBodyCell>
                                        <TableBodyCell modify={'right'}>
                                            {member.isHiddenStatistics ? <HiddenStatisticsIcon t={t} /> : <FormattedLastBattleTime date={member.lastBattleTime} isHidden={false} />}
                                        </TableBodyCell>
                                        {isDisabled ? <DivTooltip className={styles.disabledTooltip} tooltipBody={<TooltipBody>
                                                        <Interpolate i18nKey={x('Игрок состоит в клане менее %(days)s дней')} days={this.props.treasuryMinDaysInClan} t={t} />
                                                    </TooltipBody>} /> : null}
                                    </TableRow>;
            })}
                        </TableBody>
                    </Table>
                </div>
                <div className={styles.distributionActions}>
                    <Button isDisabled={this.props.distributionList.length === 0} onClick={this.props.showDistributionDialog}>
                        {t('Распределить')}
                    </Button>
                </div>
            </div>;
  }
}

export default Distribution;